import { defineMessages } from 'react-intl';

const messages = defineMessages({
    breadcrumbLabel: {
        defaultMessage: 'Breadcrumb',
        description: 'Aria label for describing "breadcrumb"',
        id: 'boxui.breadcrumb.breadcrumbLabel',
    },
});

export default messages;
